import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import {
  ProcessingReceivingSource,
  ProcessingReceivingTarget,
} from "./processing-receiving-source";

export const setProcessingSourceReceivingBin = {
  name: "setProcessingSourceReceivingBin" as const,
  input: z.object({
    target: ProcessingReceivingTarget,
    workstationId: z.string().min(1),
    locationId: locationIdFormat.schema,
    sourceReceivingBinId: storageLocationIdFormat.schema.nullable(),
  }),
  output: ProcessingReceivingSource,
};
